import React, { useState } from 'react';
import { NextPageWithLayout } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import extractFromContext from '@helpers/utils/extract-from-context';
import ProfessionalSellersLanding from '@components/professional-sellers/landing/landing';
import ProfessionalSellersForm from '@components/professional-sellers/form/form';
import { useAnalytics } from '@context/analytics.context';
import DefaultLayout from '@layouts/default-layout';

const ProfessionalSellersPage: NextPageWithLayout = () => {
  const { sendEvent } = useAnalytics();

  const [currentStep, setCurrentStep] = useState<number>(0);

  const handleCTAClick = (clickLocation: 'header' | 'footer') => {
    switch (currentStep) {
      case 0:
        sendEvent({
          type: 'event',
          payload: {
            event: 'professional_seller_landing',
            button_label: 'apply',
            button_location: clickLocation,
          },
        });
        setCurrentStep(1);
        break;
      case 1:
        break;
    }
  };

  return (
    <>
      {currentStep === 0 && <ProfessionalSellersLanding onCTAClick={handleCTAClick} />}
      {currentStep === 1 && <ProfessionalSellersForm onCTAClick={handleCTAClick} />}
    </>
  );
};

ProfessionalSellersPage.Layout = [DefaultLayout];
ProfessionalSellersPage.PageType = 'ProfessionalSellersPage';

export async function getServerSideProps(context) {
  const { locale } = extractFromContext(context);

  const translations = await serverSideTranslations(locale, ['default-layout', 'professional-sellers', 'common']);
  return {
    props: {
      ...translations,
    },
  };
}

export default ProfessionalSellersPage;
